import { IDagKvantitet } from "../../../../common/models/dagkvantitet";
import { CommandBase } from "../../../../common/services/cqs/commandManager";

export class SetLeveransradAvtaladKvantitetCommand extends CommandBase {
    kundorderradId: number;
    periodStart: Date;
    periodEnd: Date;
    avtaladKvantitet: IDagKvantitet[];

    constructor(init: (instance: SetLeveransradAvtaladKvantitetCommand) => void) {
        super("SetLeveransradAvtaladKvantitetCommand");
        init(this);
    }
}
